module.exports = __webpack_public_path__ + "static/media/new_identification_card_front.533d01a0.svg";